import page from 'page'
import React from 'react'
import { isEmpty } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle } from 'recompose'
import { injectIntl } from 'react-intl'

import { getFullInfo, getSimilar, subscribe } from '../store/reducers/lots/single.js'
import { getLoggedUser } from '../selectors/user.js'
import { getLotName, getSimilarLots, getLotInfo, getLastBidValue } from '../selectors/lots.js'

import MainContainer from './Main'
import Sidebar from '../components/Lot/Sidebar'
import Person from '../components/Person'


const LotPage = ({ data = {}, name, closeBidOverlay, bidId, id, bidOverlay, onBidAdd}) => {
  if (!data || isEmpty(data)) return null
  data.title = name
  if (data.bidsStats){
    data.sum = data.bidsStats.maxBid + " " + data.currency.symbol
  }
  data.statsDifference = null
  
  return (
    <div className={"PreviewLots"}> 

      <div className={"Container"}> 
        <h1></h1>
        <section className={"Persons__list"}>
          <Person data={data} isSpecial={false} />
        </section>
      </div>

      <div className={"Container"}> 
        <h1></h1>
      </div>
      {data.photos.map(key => {
        return (
          <MainContainer  sidebarClass='Sidebar_person ' Sidebar={<Sidebar data={{ ...data, name }} imageToPreview={key} person={data.persons} />}>
            {data.description && <div className='Main__description Text' dangerouslySetInnerHTML={{ __html: data.description }} />}
          </MainContainer>
        )}      
      )}

    </div>
  )}

const mapStateToProps = state => ({
  data: getLotInfo(state),
  similar: getSimilarLots(state),
  bids: state.lots.single.bids,
  bidMessage: state.lots.single.bidMessage,
  name: getLotName(state),
  lastBid: getLastBidValue(state),
  user: getLoggedUser(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ getFullInfo, getSimilar, subscribe }, dispatch)

const mergeProps = (state, dispatch, props) => ({
  ...props,
  ...state,
  getFullInfo: async (id) => {
    id = id || props.id
    if (!id) return
    let result = await dispatch.getFullInfo(id, {typelot:'lot'})
    if (result === 200) await dispatch.getSimilar(id)
    else props.on404()
  },
  onBidAdd: async (id) => {
    id = id || props.id
    if (!id) return
    let result = await dispatch.getFullInfo(id, { noRewrite: true })
    if (result === 200) {
      props.setBidOverlay(false)
      page(`/lots/${id}`)
    }
  },
  subscribe: async flag => {
    if (!props.id || !state.data) return
    await dispatch.subscribe(props.id, !state.data.isSubscribed)
  }
})

export default injectIntl(compose(
  withState('stillActive', 'setStill', false),
  withState('bidLength', 'setBidLength', 5),
  withState('bidOverlay', 'setBidOverlay', null),
  withState('bidClosed', 'setBidClosed', false),
  withHandlers({
    lotClosed: (data) => (e) => {
      //скрываем кнопку Сделать ставку
      data.setBidClosed(true)
    },
    setBidOverlay: ({ setBidOverlay }) => (flag, e) => {
      e && e.preventDefault()
      setBidOverlay(flag)
    },
    setBidLength: ({ setBidLength }) => (num, e) => {
      e && e.preventDefault()
      setBidLength(num)
    },
    closeBidOverlay: ({ id, bidId, setBidOverlay }) => e => {
      e && e.preventDefault()
      setBidOverlay(false)
      if (bidId) page(`/lots/${id}`)
    }
  }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps, state => ({currentLocale: state.intl.locale})),
  lifecycle({
    componentWillMount () {
      this.props.getFullInfo()
    },
    componentDidMount () {
      this.props.setStill(false)
      this.props.bidId && this.props.setBidOverlay(true)
    },
    componentWillReceiveProps (np) {
      if (np.bidId && (np.bidId !== this.props.bidId)) this.props.setBidOverlay(true)
      if (np.id && (np.id !== this.props.id)) this.props.getFullInfo(np.id)
    }
  })
)(LotPage))



// WEBPACK FOOTER //
// ./src/containers/PreviewLot.jsx